import styled, { css } from 'styled-components'
import { Button } from '../../ButtonV1/styles'

export const CopyContainer = styled.div`
  width: 100%;
`
export const SubmitButton = styled(Button)`
  width: 100%;
  align-self: center;
`
